




























import Vue from 'vue';
import { mapGetters } from 'vuex';
import Header from '@/components/Header.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import Pagination from '@/components/Pagination.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import ExamGroupCard from '@/components/cards/ExamGroupCard.vue';

export default Vue.extend({
  components: {
    Header,
    pxButton,
    Pagination,
    Loading,
    ExamGroupCard,
  },

  data() {
    return {
      currentPage: 0,
      loaded: true,
    };
  },

  computed: {
    ...mapGetters({
      allExamGroups: 'allExamGroups',
    }),
  },

  async mounted() {
    const page = parseInt(this.$route.params.page);
    if (page > 0) {
      this.currentPage = page - 1;
    } else {
      this.$router.replace(`/simulados`);
    }
    this.loaded = false;
    try {
      await this.$store.dispatch('PULL_EXAM_GROUPS', this.currentPage);
    } catch (e) {
      alert(
        `Algo deu errado. Envie essas informações para os desenvolvedores: ${e}`,
      );
    }
    this.loaded = true;
    this.$store.dispatch('PULL_ALL_BOARDS');
  },

  methods: {
    changePage: async function(event: number) {
      this.currentPage = event;
      this.loaded = false;
      await this.$store.dispatch('PULL_EXAM_GROUPS', this.currentPage);
      this.loaded = true;
      this.$router.push(`/simulados/${this.currentPage + 1}`);
    },
  },
});
